import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faSliders,faCheck,faPhotoFilm,faStar,faXmark, faDownload, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh, faArrowRight,faBus, faMapLocationDot, faHotel, faMessage, faSquareArrowUpRight,faChevronDown, faMicrophone,faChevronUp, faBowlFood, faMountain} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin, } from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import {useEffect}from 'react'
import PackageSlider from "./Component/PackageSlider";
import Bookingform from "./Component/bookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import TourNav from './Component/stickynav';
const packages = [
  {
    title: "7 Unesco Heritage Tour",
    days: "8 Hours",
    duration: "8-9 Hours",
    difficulty: "Easy",
    price: 190,
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.jpeg",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  },
  {
    title: "Mountain Flight",
    days: "1 Hours",
    duration: "1 Hours",
    difficulty: "Easy",
    price: 280,
    image: "/img/mounteve/moun1.webp",
    link: "/mountain-flight-nepal-tour"
  },
  {
    title: "Nature Majestic Loop",
    location: "Nepal",
    days: "10 Days",
    difficulty: "Easy",
    price: 2350,
    duration: "10 Days",
    image: "/img/treek/Dhampus.webp",
    link: "/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"
  }
];
const images = [
  "/img/capital/ch.webp",
  "/img/capital/bouddha.webp",
  "/img/capital/swyambhunath1dslr.jpeg",
  "/img/capital/swoyambhunath.jpg",
  "/img/capital/image-asset.webp",
  "/img/capital/capital1dslr.jpeg",
 "/img/capital/swyambhunath.webp",
  "/img/capital/kathmandu2.jpg",
  "/img/capital/swyambhunathdslr.jpeg"
];
const Kathnight = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [count,Setcount]=useState(12);
  const [day1Open, setDay1Open] = useState(false);
  const [day2Open, setDay2Open] = useState(false);
  const [day3Open, setDay3Open] = useState(false);
  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  const getmul=(qty)=>{
if(qty>=12)return 10000;
    };
    const totalprice =count*getmul(count);
    const [opent, seT] = useState(false);
    const [opente, seTe] = useState(false);
    const [openr, seTr] = useState(false);
     useEffect(()=>{
      if(opent){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[opent]);
    const [activeIndex, setActiveIndex] = useState(null);
    
    const toggleFaq = (index) => {
      if (activeIndex === index) {
        setActiveIndex(null);
      } else {
        setActiveIndex(index);
      }
    };
    const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');

const handleLogin = (e) => {
    e.preventDefault();
    if (password === 'tft&htpb2b') {
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password');
    }
  };
if (!isAuthenticated) {
    return (
      <div style={{ zIndex: '1000',backgroundColor: 'red',display: 'flex', height: '0vh', alignItems: 'center', justifyContent: 'center' }}>
        <form onSubmit={handleLogin} style={{ zIndex: '1000',backgroundColor: 'white',display: 'flex', flexDirection: 'column', gap: '1rem', padding: '2rem', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>B2B Partner Access Only</h2>
          <input
            type="password"
            placeholder="Enter access password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ border: '1px solid #ccc', padding: '0.5rem', borderRadius: '4px' }}
          />
          <button type="submit" style={{ backgroundColor: '#2563eb', color: 'white', padding: '0.5rem', borderRadius: '4px', border: 'none', cursor: 'pointer' }}>View Page</button>
        </form>
      </div>
    );
  }
  return (
   <main>
 <TourNav />
    <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">Trip Flyer Travels & Himalayas Travels</h1>

    <div className="breadcrumb">
      Kathmandu<span> 2 Nights/3 Days Tour</span>
    </div>
    <div className="everest-image">
        <div className="everest-full">
          <img src="/img/capital/ch.webp" alt="error" />
          <div
      className="tourgps"
      onClick={() => setOpen(true)}
    >    <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
       </div>
        </div>
        <div className="everest-half">
        <div className="image-box"> <video src="/video/videodslr.mp4" controls autoPlay muted loop></video></div>
            <div className="image-box"> <img src="/img/capital/swoyambhunath.jpg" alt="error" /></div>
        </div>
     </div>
     {open && (
  <div className="roomModal tourgr">
    <div className="roomModal__content">

      <div
        className="roomModal__close"
        onClick={() => setOpen(false)}
      >
        ✕
      </div>

      <img
        src={images[index]}
        alt="big"
        className="roomModal__image"
      />

      <div
        className="roomModal__nav roomModal__nav--left"
        onClick={prev}
      >
        ❮
      </div>

      <div
        className="roomModal__nav roomModal__nav--right"
        onClick={next}
      >
         ❯  
      </div>

      <div className="roomModal__thumbs">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="thumb"
            className={
              index === i
                ? "roomModal__thumb active"
                : "roomModal__thumb"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  </div>
)}
    <div className="Trip-fact">
      <h3>Trip Facts</h3>
      <div className="grid">
        <div className="grid-item">
          <FontAwesomeIcon icon={faCalendarDays}/>
          <div className="grid-item-next">
            <p className='Dur'>Duration</p>
            <p className='Duration'>3 Days</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faCloud}/>
          <div className="grid-item-next">
            <p className='Dur'>Best Time</p>
            <p className='Duration'>All Year</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faGaugeHigh}/>
          <div className="grid-item-next">
            <p className='Dur'>Grade</p>
            <p className='Duration'>Easy</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBus}/>
          <div className="grid-item-next">
            <p className='Dur'>Transportation</p>
            <p className='Duration'>Private Ac Vehical</p>
          </div>
        </div>
 
        <div className="grid-item">
          <FontAwesomeIcon icon={faMapLocationDot}/>
          <div className="grid-item-next">
            <p className='Dur'>Type Of Tour</p>
            <p className='Duration'>Cultural and Heritage Tour</p>
          </div>
        </div>

         <div className="grid-item">
          <FontAwesomeIcon icon={faHotel}/>
          <div className="grid-item-next">
            <p className='Dur'>Hotel Included</p>
            <p className='Duration'>3 Stars</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBowlFood}/>
          <div className="grid-item-next">
            <p className='Dur'>Breakfast Lunch & Dinner</p>
            <p className='Duration'>Included</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faMountain}/>
          <div className="grid-item-next">
            <p className='Dur'>Maximum Elevation</p>
            <p className='Duration'>2,551 M</p>
          </div>
        </div>

      </div>

       </div>
       <div className="overview-container"id='overview'>
  <div className="heading">Highlights Of Tours</div>
  <div className="flex-p">
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Enjoy stunning Himalayan views from the peaceful Chandragiri Hill summit.</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Experience spiritual serenity at the iconic Boudhanath Stupa and Swyambhunath.</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Explore Kathmandu Durbar Square's historic royal palaces.</p>  
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Enjoy Traditional Nepali Culture</p>  
</div>
</div>
       <div className="overview-container">
  <div className="overview-heading">Overview</div>

  <div className="overview-text">
 If you have a few days and want to truly feel the heartbeat of Kathmandu, this is for you. We’ve designed this short trip to take you beyond the typical tourist spots, focusing on the incredible history and soul of the valley. It’s a mix of ancient city squares, peaceful hilltop views, and the quiet spiritual energy that makes our home so special.
  </div>
  <div className="heading smalling">Places You’ll Visit:</div>
  
  <div className="flex-p">
  
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Swayambhunath (Monkey Temple):</b> Ancient hilltop stupa offering panoramic views and deep Buddhist symbolism.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Bouddha Stupa:</b> One of the world's largest spherical Buddhist monuments.</p>

  
   
  

  
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Kathmandu Durbar Square:</b> A historic complex of palaces, courtyards, and temples reflecting royal Malla history.</p>
  

  
    
  


    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Chandragiri Hills:</b> Scenic hilltop destination near Kathmandu offering panoramic Himalayan mountain views..</p>
  </div>
<div className="heading smalling">Introduction Of Places</div>

<p className='overview-text'><b>Boudhanath: The Giant Circle</b> This is one of the biggest stupas in the world, built like a giant meditation map. The air is thick with the smell of butter lamps and the sound of monks chanting. Thousands of people walk in a circle here every day, but the peace you feel inside is a secret you have to experience yourself.</p>
<p className='overview-text'><b>Kathmandu Durbar Square: Secrets of the Living Goddess</b> Walk the same stone paths as ancient kings and seek a glimpse of the Kumari—the world’s only Living Goddess. This "Museum of Living Heritage" is a maze of hidden courtyards and towering pagodas that survived the test of time. There is a specific mystery in the air here, a feeling that a legend could walk around the corner at any moment. Are you ready to step into the palace of shadows and stories?</p>
 <p className='overview-text'><b>Swayambhunath: The All-Seeing Eyes</b> High on a hill, ancient eyes watch over the entire valley. Legend says this place was born from a lotus flower before the city even existed. You will walk among hundreds of monkeys and spinning wheels to find a view that feels like the top of the world. What you see here will stay with you forever.</p>
<p className='overview-text'><b>Chandragiri Hills: Scenic peaks, historical views.</b> Soar above the Kathmandu Valley on a scenic cable car ride to a majestic vantage point offering panoramic Himalayan views and echoes of King Prithvi Narayan Shah. Experience tranquil magic and crisp mountain air at this legendary peak where history meets the horizon.</p>

</div>
<div className="overview-container">
  <div className="overview-heading">Why This Package ?</div>
<div className="heading smalling">A Truly Cultural Experience</div>
<p className='overview-text'>Beyond just sightseeing, you’ll walk through the ancient, living history of our city squares and temples exactly as we have for centuries.</p>

<div className="heading smalling">Thoughtfully Balanced Pace</div>
<p className='overview-text'>We mix the vibrant energy of the historic Durbar Squares with the quiet, peaceful atmosphere of holy sites to ensure you stay relaxed.</p>

<div className="heading smalling">The Essential Highlights</div>
<p className='overview-text'>You’ll hit all the must-see UNESCO sites—from Kathmandu Durbar Square to Swayambhunath and Boudhanath—giving you a complete view of our culture.</p>

<div className="heading smalling">Hassle-Free Exploration</div>
<p className='overview-text'>We take care of all the logistics and transport, so you can simply focus on the food, the architecture, and the incredible atmosphere of Nepal.</p>
</div>

<div className="overview-container">
  <div className="overview-heading"id='itinerary'>ITINERARY</div>
  <div className="timeline-row">
        <div className="timeline-left">
          <div className="day-circle">Day 1</div>
        </div>

        <div
          className="timeline-right"
          onClick={() => setDay1Open(!day1Open)}
        >
         
          <div className="timeline-title">
      Arrival in Kathmandu
          </div>

          <div className="arrow-icon">
            <FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
      </div>

      {day1Open && (
        <div className="timeline-detail">
     Your journey begins with a warm welcome upon arrival in Kathmandu. You will be greeted with a traditional Khada—a silk scarf symbolizing purity and compassion. Afterward, enjoy lunch before visiting Bouddha Stupa. You will then head to your hotel located right in the center of Thamel, Kathmandu's vibrant tourist hub, concluding your first day with a delightful evening dinner.
        </div>
      )}
<div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 2</div>
        </div>
        <div
          className="timeline-right"
          onClick={() => setDay2Open(!day2Open)}
        > 
          <div className="timeline-title">
          Cultural Landmarks and Mountain Views
          </div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day2Open ? faChevronUp : faChevronDown} />
          </div>
          
        </div>
        
</div>
{day2Open && (
        <div className="timeline-detail">
     After breakfast, your day begins with a tour of the historic Kathmandu Durbar Square, followed by a visit to the iconic Swayambhunath Stupa (Monkey Temple). After lunch, you will head to Chandragiri Hills via cable car to enjoy panoramic Himalayan views, then head back to the hotel to have dinner and rest.
        </div>
      )}

      <div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 3</div>
        </div>
        <div
          className="timeline-right"
          onClick={() => setDay3Open(!day3Open)}
        > 
          <div className="timeline-title">
         Departure
          </div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day3Open ? faChevronUp : faChevronDown} />
          </div>
          
        </div>
        
</div>
{day3Open && (
        <div className="timeline-detail">
     After taking breakfast, you will be transferred from your hotel to the airport for your flight back home, carrying memories of your time in Nepal.
        </div>
      )}
     
   
</div>

<div className="overview-container width-hund"id='included'>

<div className="cost-box included">
        <div className="cost-title">Cost Included</div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
          Airport Pick Up and Drop with private vehicle is included in this price.
          </div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">A English Speaking Local guide.</div>
        </div>
<div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
           Private AC vehicle for transfers & sightseeing is included in this price.
          </div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Two nights of accommodation (Double Sharing) in a 3-star hotel in Kathmandu, including daily breakfast.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All kind of service charge and Tax is included.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All the applicable entrance fees.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Lunch and Dinner during the tour.</div>
        </div>
      </div>



      {/* COST EXCLUDED */}
      <div className="cost-box excluded">
        <div className="cost-title">Cost Not Included</div>

 <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Chandragiri cable car ticket is not included. It requires an extra 1000 BDT.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">International airfare and airport departure tax.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Tips for the guide & driver.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Any others expenses which are not mentioned in including section.</div>
        </div>
      </div>

</div>
<div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> Useful Info
  </div>
  <section className="faq">
      <div className="faq-container">

        <div className="faq-list">
          

          

 <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
            This four-day tour is meticulously designed for first-time visitors and time-conscious travelers who want to experience the soul of Nepal without the physical demands of high-altitude trekking. It is a perfect fit for cultural enthusiasts and history buffs who are eager to step into a living past, as it navigates the intricate palaces and spiritual rituals of three distinct UNESCO World Heritage cities. Families and multi-generational groups will find the pace comfortable and the logistics seamless, offering a stress-free way to share the magic of ancient temples and local traditions.
Furthermore, this itinerary is a dream for photography enthusiasts and nature lovers who seek "soft adventure"; it provides the rare opportunity to witness a world-class Himalayan sunrise from the comfort of a Nagarkot balcony. Whether you are a spiritual seeker looking to connect with the deep-rooted energy of sacred sites like Pashupatinath and Boudhanath, or a busy professional in need of a high-impact mountain escape, this package delivers the ultimate "best of Nepal" experience in a condensed, high-reward format.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies Cancel up to 10 days before in advance for a full refund after 10 days there will no refund of your 10% payment.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Travel Documents:</b> Ensure you have a valid passport and printed copies of your booking confirmation and insurance.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Clothing & Layers:</b> Pack lightweight clothes for the city and a warm jacket for the Nagarkot sunrise, as temperatures drop significantly in the mornings.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Footwear:</b> Bring comfortable walking shoes or sneakers with good grip for navigating the stone-paved streets of Bhaktapur and the hills of Nagarkot.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Health & Safety:</b> Carry a basic first-aid kit, personal medications, and a reusable water bottle to stay hydrated while exploring the heritage sites.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Day Pack:</b> Use a small backpack to keep your camera, power bank, and rain gear handy for sudden mountain weather changes.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Currency & Cash:</b> Keep some local currency (NPR) for personal expenses, tips, and meals not included in the package.</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          
<div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  </div>
<div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      The Everest Heli Tour was a dream come true. The views were unreal and
      the helicopter experience was smooth and luxurious.
    </div>

    <div className="review-user">
      <div className="user-avatar">A</div>
      <div className="user-info">
        <div className="user-name">Alex Morgan</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Perfect for travelers with limited time. In just a few hours, we saw
      Everest up close without any physical effort.
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sophia Lee</div>
        <div className="user-country">Singapore</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Highly recommended! Stunning mountain views, professional crew, and
      an unforgettable helicopter flight over the Himalayas.
    </div>

    <div className="review-user">
      <div className="user-avatar">R</div>
      <div className="user-info">
        <div className="user-name">Rahul Verma</div>
        <div className="user-country">India</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book" onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text">Book Now</div>
</div>

<div className="cta-button customize" onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review" onClick={()=>seTr(true)}>
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
  
</div>

</div>
    </div>
    <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>10000 BDT</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>For Min 12 Person</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>12){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>৳{totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/legal" className="download">
               
                  <h6>See Legal Documents</h6>
                </Link>
                <div className="booking-btn">
                <button onClick={()=>seT(true)}>Book Now</button>
      <button onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip Expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
               src="/img/company/destination expert.png" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="012shy1234@gmail.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section>
   </div>
     <h2 className="hws">Similar Packages</h2>
     <PackageSlider packages={packages} />
     <section className='sticky-bott'>
     <div className="booking-btn">
     <button onClick={()=>seT(true)}>Book Now</button>
      <button onClick={()=>seTe(true)}>Enquiry Now</button>
    </div>
     </section>
     {opent &&(  <section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <Bookingform src="/img/capital/Nagarkot.avif" title="B2B Trip Flyer Travels"/></section>)}
{opente &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/capital/Nagarkot.avif" title="b2b Trip Flyer Travels"/></section>)}
{openr &&(  <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Review /></section>)}
   </main>
  )
}
export default Kathnight